var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Graph 1"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_89_4117",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 32,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Graph 1 (Background/Mask)",
    y: -0.000244141,
    width: 32,
    height: 32,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_89_4117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6704 7.84558L14.0416 13.3655L14.2259 16.1399C14.2279 16.4253 14.2725 16.7087 14.3588 16.9811C14.5813 17.5099 15.1168 17.8459 15.6993 17.8225L24.5756 17.2418C24.96 17.2355 25.3312 17.3793 25.6075 17.6415C25.8377 17.8601 25.9864 18.1459 26.0333 18.4534L26.0491 18.6401C25.6817 23.7263 21.9461 27.9687 16.8704 29.0638C11.7946 30.1589 6.58967 27.8455 4.08147 23.3797C3.35837 22.0822 2.90672 20.6562 2.75303 19.1851C2.68883 18.7497 2.66056 18.3098 2.66849 17.8698C2.66056 12.4168 6.54382 7.70241 11.9796 6.56589C12.6339 6.46401 13.2752 6.81035 13.5376 7.40717C13.6055 7.54538 13.6503 7.69341 13.6704 7.84558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M29.3335 13.0828L29.3242 13.1262L29.2973 13.1894L29.301 13.3629C29.2871 13.5926 29.1983 13.8137 29.0455 13.9924C28.8862 14.1784 28.6686 14.305 28.429 14.3542L28.2829 14.3742L18.0418 15.0378C17.7011 15.0714 17.3619 14.9616 17.1087 14.7357C16.8975 14.5473 16.7626 14.2932 16.7245 14.0193L16.0371 3.79313C16.0251 3.75855 16.0251 3.72107 16.0371 3.68649C16.0465 3.40461 16.1706 3.13817 16.3817 2.94669C16.5926 2.75521 16.8731 2.65465 17.1602 2.66747C23.2401 2.82215 28.3499 7.1941 29.3335 13.0828Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.9e8a92abd5d1a708830daa1213675062.svg";
export { ForwardRef as ReactComponent };